import React from 'react';
import * as Utils from "../../inc/Utils";
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useParams, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import Select from 'react-select'
import moment from "moment-timezone";

export default function AdsSetnameGroupItemEditSpecial() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let adsSetnameGroupItemId = decode.id;
    let adsSetnameGroupId = decode.adsSetnameGroupId;
    let adsSetnameGroupTitle = decode.adsSetnameGroupTitle;

    let backPath = '/adsSetnameGroupItem/' + Utils.encodeItem({id: adsSetnameGroupId, adsSetnameGroupTitle: adsSetnameGroupTitle});

    let btnTextDefault = 'อัพเดตข้อมูล';
    let btnTextLoading = 'กำลังอัพเดต..';
    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState('');
    let [statusChecked, setStatusChecked] = React.useState(false);
    let [adsNaming, setAdsNaming] = React.useState('');

    let [adsNamingSetNameType, setAdsNamingSetNameType] = React.useState('');
    let [adsNamingSetNameTypeId, setAdsNamingSetNameTypeId] = React.useState(null);

    let [platform, setPlatform] = React.useState('');
    let [platformId, setPlatformId] = React.useState(null);

    let [kolPage, setKolPage] = React.useState('');

    let [itemFreeForm, setItemFreeForm] = React.useState('');
    let [itemSelected, setItemSelected] = React.useState('');

    const navigate = useNavigate();

    let refName = React.useRef();

    React.useEffect(() => {
        (async function() {
            try {
                const resPlatform = await Utils.getPlatformAll();
                setPlatform(resPlatform);

                const resSetNameType = await Utils.getAdsNamingSetNameType();
                setAdsNamingSetNameType(resSetNameType);

                //region default kol id
                const resKolPage = await Utils.getKol();
                setKolPage(resKolPage);

                const resAdsNaming = await Utils.getAdsNamingSetName();

                //region duplicate
                if(adsSetnameGroupItemId) {
                    const resView = await getView();
                    setData(resView);
                    setStatusChecked(resView.status===1);
                    refName.current.value = resView.name;

                    if(resPlatform !== null && resView.adsPlatformId !== null) {
                        setPlatformId(resPlatform.filter(e => e.id === resView.adsPlatformId)[0]);
                    }

                    let sourceTypeSelectedIds = [];
                    if(resView) {
                        let items = resView.items;
                        if(items) {
                            for(let rs of items) {
                                let adsNamingSourceId = rs.adsNamingSourceId;
                                if(adsNamingSourceId) {
                                    if(rs.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                                        sourceTypeSelectedIds.push(adsNamingSourceId + ':KOL' + rs.adsNamingId);
                                    }
                                    else {
                                        sourceTypeSelectedIds.push(adsNamingSourceId);
                                    }
                                }
                            }
                        }
                        setItemSelected(sourceTypeSelectedIds);
                    }

                    //setup default ads naming
                    if(resAdsNaming.length > 0) {

                        setAdsNaming(resAdsNaming);

                        let items = resView.items;
                        resAdsNaming.map((rs, index2) => {
                            let inputType = rs.inputType;
                            if(inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                                let newKolPageId = [];
                                if(resKolPage) {
                                    for(let row of resKolPage) {
                                        let json  = {
                                            id: row.id + ':KOL' + rs.id,
                                            name:  row.name
                                        };
                                        newKolPageId.push(json);
                                    }
                                    rs.source = newKolPageId;
                                }
                            }
                            else if(inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                                if(items) {
                                    for(let item of items) {
                                        if(item.inputType === Utils.ADSNAMING_TYPE_FREEFORM && item.text) {
                                            setItemFreeForm(item.text);
                                            break;
                                        }
                                    }
                                }
                            }
                        })
                    }
                    setAdsNaming(resAdsNaming);
                    //end

                    if(resSetNameType) {
                        for(let ln of resSetNameType) {
                            if(ln.id === resView.adsNamingSetNameTypeId) {
                                setAdsNamingSetNameTypeId({id: ln.id, name: ln.name});
                                break;
                            }
                        }
                    }
                }
                //endregion
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getView() {
        const response = await fetch(Config.url.API_URL +'/api/adsSetnameGroupItem/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: adsSetnameGroupItemId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onUpdate = async () => {

        let param = await getParams();
        let name = refName.current.value;

        if(!name) {
            toast.error("กรุณาระบุ ชื่อ Group Item");
            refName.current.focus();
        }
        else if(!param.success) {
            toast.error("กรุณาเลือก Parameters ให้ครบถ้วน");
        }
        else if(!adsNamingSetNameTypeId) {
            toast.error("กรุณาระบุ Type");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                id: data.id,
                                name: name,
                                currentName: data.name,
                                adsSetnameGroupId: adsSetnameGroupId,
                                adsNamingSetNameTypeId: adsNamingSetNameTypeId ? adsNamingSetNameTypeId.id : null,
                                adsPlatformId: platformId ? platformId.id:null,
                                status: statusChecked[0].checked ? 1:0,
                                updatedBy: userId,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                sourceTypeIds: param.data
                            };

                            fetch(Config.url.API_URL +'/api/adsSetnameGroupItem/update', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate(backPath, {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeAdsNamingSetNameTypeId = (obj) => {
        setAdsNamingSetNameTypeId(obj);
    };

    async function getParams() {
        let textParams = [];
        let sourceIds = [];
        let kolIds = [];

        //STEP 1 : Find Selected
        let sourceTypeIds = [];
        let sourceTypeAllIds = [];
        let selectSourceTypeIds = document.getElementsByName('sourceTypeIds[]');
        if(selectSourceTypeIds) {
            for(let st of selectSourceTypeIds) {
                let sourceTypeId = st.value;
                if(sourceTypeId) {
                    //STEP 1.1 : Find special selector
                    if(sourceTypeId.includes(':KOL')) {
                        let sp = sourceTypeId.split(':KOL');
                        let kolId = sp[0];
                        let adsNamingId = sp[1];
                        if(kolId) {
                            let find = kolPage.find(rs => {
                                if(parseInt(rs.id) === parseInt(kolId)) {
                                    return rs;
                                }
                            });
                            kolIds.push({
                                adsNamingSourceId: parseInt(kolId),
                                adsNamingId: parseInt(adsNamingId),
                                name: find ? find.name : null,
                                inputType: Utils.ADSNAMING_TYPE_KOL_PAGE
                            });
                        }
                    }
                    else {
                        sourceTypeIds.push(sourceTypeId);
                    }
                    sourceTypeAllIds.push(sourceTypeId);
                }
            }
        }

        //STEP 2 : Get selector type
        if(sourceTypeIds.length > 0) {
            let result = await Utils.getSourceTypeForParam(sourceTypeIds);
            if(result) {
                for(let row of result) {
                    sourceIds.push({
                        adsNamingSourceId: row.id,
                        adsNamingId: row.adsNamingId,
                        name: row.name,
                        inputType: null
                    });
                }
            }
        }

        //STEP 4 : Get for params
        if(adsNaming.length > 0) {
            adsNaming.map(async (row, index) => {
                let value = '';
                let inputText = "sourceTypeText[" + row.id + "]";
                let textSourceTypeIds = document.getElementsByName(inputText);
                if(textSourceTypeIds && textSourceTypeIds[0]) {
                    value = textSourceTypeIds[0].value;
                    if(value.length > 0 || row.inputType === Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: value,
                            inputType: row.inputType
                        });
                    }
                }
                else {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        if(kolIds) {
                            let find = kolIds.find(kol => {
                                if(kol.adsNamingId === row.id) {
                                    return kol;
                                }
                            });
                            if(find && find.name) {
                                textParams.push({
                                    adsNamingSourceId: find.adsNamingSourceId,
                                    adsNamingId: row.id,
                                    text: find.name,
                                    inputType: row.inputType
                                });
                            }
                        }
                    }
                    else {
                        let find = sourceIds.find(rs => {
                            if(parseInt(rs.adsNamingId) === parseInt(row.id)) {
                                return rs;
                            }
                        });
                        if(find && find.name) {
                            textParams.push({
                                adsNamingSourceId: find.adsNamingSourceId,
                                adsNamingId: row.id,
                                text: find.name,
                                inputType: null
                            });
                        }
                    }
                }
            });
        }

        return {params: null, data: textParams, success: sourceTypeAllIds.length === selectSourceTypeIds.length};
    }

    const onChangePlatformId = (platformRow) => {
        setPlatformId(platformRow);
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-12 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Ads Setname Group  Item</div>
                    <span className="ms-1">/</span> <span className="text-danger fw-bold">{adsSetnameGroupTitle}</span>
                    <span className="ms-1">/</span> <span className="text-muted">Edit (Special)</span>
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form>
                            <div className="row g-3 border rounded bg-light p-2 mt-0 mb-3">
                                <div className="col-12 mt-1">
                                    <label htmlFor="name" className="form-label">ชื่อ Group Item <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" id="name" ref={refName} maxLength={100} />
                                </div>
                                <div className="col-12">
                                    <label htmlFor="projectTypeId" className="form-label">Platform</label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={platform}
                                        onChange={(event) => onChangePlatformId(event)}
                                        value={platformId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                            </div>

                            <div className="row g-3 border rounded bg-yellow-light p-2 my-3">
                                {
                                    adsNaming.length <= 0 ? (<p>ไม่พบข้อมูล Ads Naming</p>) :
                                        adsNaming.map((row, index) => {
                                            let inputText = "sourceTypeText[" + row.id + "]";
                                            let formId = '';
                                            let rsSource = row.source;
                                            let inputType = row.inputType;
                                            let selected = null;

                                            if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                                                //--
                                            }
                                            else if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                                                //--
                                            }
                                            else if(inputType === Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                                                formId = 'slug-special';
                                                return (
                                                    <div key={index}>
                                                        <div className="d-block fw-bold">{row.name}
                                                            <span className="text-muted small d-block fw-light">{'{BG}_{Slug Special}|{Target Source}_{Platform}|{Type}_[ST]'}</span>
                                                        </div>
                                                        <div className=" css-b62m3t-container"><input className="form-control" type="text" id={formId} name={inputText} disabled={true} /></div>
                                                    </div>
                                                );
                                            }
                                            else if(inputType === Utils.ADSNAMING_TYPE_FREEFORM){
                                                formId = 'freeform';
                                                return (
                                                    <div key={index}>
                                                        <div className="d-block fw-bold">{row.name}</div>
                                                        <div className=" css-b62m3t-container"><input className="form-control" type="text" id={formId} name={inputText} defaultValue={itemFreeForm} onKeyUp={e => {
                                                            if(e && e.target.value) {
                                                                e.target.value = Utils.utmSlug(e.target.value);
                                                            }
                                                        }} /></div>
                                                    </div>
                                                );
                                            }
                                            else {
                                                if(inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                                                    for(let cs of rsSource) {
                                                        let id = cs.id;
                                                        let sp = id.split(':KOL');
                                                        let kol = parseInt(sp[0]) +':KOL'+ parseInt(row.id);
                                                        if(itemSelected.length && itemSelected.includes(kol)) {
                                                            selected = {id: id, name: cs.name};
                                                            break;
                                                        }
                                                    }
                                                    return (
                                                        <div key={index}>
                                                            <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                            <div className=" css-b62m3t-container">
                                                                <Select
                                                                    isClearable={true}
                                                                    name="sourceTypeIds[]"
                                                                    classNamePrefix="form-select-search"
                                                                    options={rsSource}
                                                                    defaultValue={selected}
                                                                    getOptionValue={(option) => `${option.id}`}
                                                                    getOptionLabel={(option) => `${option.name}`}
                                                                />
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                                else {
                                                    if(itemSelected.length) {
                                                        for(let cs of rsSource) {
                                                            let id = cs.id;
                                                            if(itemSelected.includes(id)) {
                                                                selected = {id: id, name: cs.name};
                                                                break;
                                                            }
                                                        }
                                                    }

                                                    if(platformId !== null && row.name !== 'BG') {
                                                        return (
                                                            <div key={index}>
                                                                <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                <Select
                                                                    isClearable={true}
                                                                    name="sourceTypeIds[]"
                                                                    classNamePrefix="form-select-search"
                                                                    options={rsSource.filter(o => o.platform.some(e => e.adsPlatformId === platformId.id))}
                                                                    defaultValue={selected}
                                                                    getOptionValue={(option) => `${option.id}`}
                                                                    getOptionLabel={(option) => `${option.name}`}
                                                                />
                                                            </div>
                                                        );
                                                    }
                                                    else {
                                                        return (
                                                            <div key={index}>
                                                                <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                <Select
                                                                    isClearable={true}
                                                                    name="sourceTypeIds[]"
                                                                    classNamePrefix="form-select-search"
                                                                    options={rsSource}
                                                                    defaultValue={selected}
                                                                    getOptionValue={(option) => `${option.id}`}
                                                                    getOptionLabel={(option) => `${option.name}`}
                                                                />
                                                            </div>
                                                        );
                                                    }
                                                }
                                            }
                                        })
                                }
                            </div>

                            <div className="row g-3 border rounded bg-light p-2 my-3">
                                <div className="col-12 mt-1">
                                    <label htmlFor="adsNamingSetNameType" className="form-label">Type <span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={adsNamingSetNameType}
                                        onChange={(event) => onChangeAdsNamingSetNameTypeId(event)}
                                        value={adsNamingSetNameTypeId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                            </div>

                            <div className="row g-3 mb-3">
                                <div className="col-12">
                                    <label htmlFor="statusx" className="form-label">สถานะ</label>
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" name="statusChecked" id="status" checked={statusChecked} onChange={e => {setStatusChecked(e.target.checked)}} />
                                        <label className="form-check-label" htmlFor="status"></label>
                                    </div>
                                </div>
                            </div>

                            <div className="row g-3">
                                <div className="col-12">
                                    <button type="button" className="btn btn-primary" onClick={onUpdate}><span
                                        className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                    <NavLink className="btn btn-sm btn-light ms-2" to={backPath}><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                    <Toaster position="bottom-right" />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 